<template>
  <div class="lg:mt-[107px] mt-[50px] flex flex-col gap-8 lg:mx-[140px] mx-4 items-center">
    <div class="flex flex-col gap-2 mx-4">
      <p class="lg:text-[32px] text-[16px] lg:text-center font-medium text-brand-green lg:mt-8">REGISTRACE</p>
      <p class="lg:text-[56px] text-[28px] text-black lg:text-center font-extrabold mb-[30px]">Vstupenky v prodeji</p>
      <p class="lg:hidden font-medium text-[14px]" style="line-height: 20.5px">Shopcamp se už přes dekádu podílí na
        vzdělávání české e-commerce díky odborným přednáškám a praktickým workshopům. Umožňuje přátelské setkání
        e-shoperů a e-commerce odborníků na jednom místě.</p>
      <p class="lg:hidden font-medium text-[14px]" style="line-height: 20.5px">Po celý den probíhá program ve dvou
        přednáškových sálech, třech workshopových místnostech a nově účastníků představíme také inspirativní mastermindy
        vedené zkušenými odborníky české e-commerce. Program doplňují partnerské stánky, kolo štěstí, skvělé
        občerstvení, uvolněná komunitní atmosféra a neformální networking.</p>
    </div>
    <div class="lg:hidden flex flex-col mb-8">

    </div>
    <div class="justify-between mx-[14px] max-w-[932px] lg:gap-[32px] gap-[50px] relative" :class="[isEarlySimpleshopRegistrationOpened ? 'md:grid-cols-2 grid' : 'flex flex-col justify-center items-center']">
      <div class="absolute h-[250px] left-0 right-0 z-[-1] top-[120px] opacity-70 bg-[#2699C6]"
           style="filter: blur(514.1500244140625px);"></div>
<!--              <div class="pr-0.5">-->
<!--              <Eshoper v-if="!eshoperIsFull" :free-registration-opened="freeRegistrationIntervalIsActive" :free-registration-interval-start="freeRegistrationIntervalStart" :free-registration-interval-end="freeRegistrationIntervalEnd"></Eshoper>-->
<!--              <Substitute v-else :free-registration-opened="freeRegistrationIntervalIsActive"></Substitute>-->
<!--              </div>-->
      <div v-if="isEarlySimpleshopRegistrationOpened" class="max-w-[450px] md:justify-self-end justify-self-center">
        <Standart :is-early-simpleshop-registration-opened="isEarlySimpleshopRegistrationOpened"
                  :early-simpleshop-registration-end="earlySimpleshopRegistrationEnd"></Standart>
      </div>
      <div class="pl-0.5 max-w-[450px] md::justify-self-start justify-self-center">
        <Premium :is-late-simpleshop-registration-opened="isLateSimpleshopRegistrationOpened"
                 :late-simpleshop-registration-end="lateSimpleshopRegistrationEnd"
                 :late-simpleshop-registration-start="lateSimpleshopRegistrationStart"></Premium>
      </div>
      <div class="md:col-span-2 justify-items-center">
        <Partner class="w-full"></Partner>
      </div>
    </div>
    <div class="lg:flex hidden flex-col gap-2 lg:mt-12 lg:ml-[20px]">
      <div>
        <p class="lg:text-[32px] text-[16px] font-[500] text-brand-orange mb-[10px] lg:mb-[30px]">INFO</p>
        <p class="font-extrabold lg:text-[56px] text-[28px] font-gray-900" style="line-height: 115%">Konference pro
          <span
            class="whitespace-nowrap">e-commerce</span> profesionály</p>
        <div class="py-[30px]">
          <p class="lg:text-[18px] text-[14px] font-gray-900">
            Shopcamp se už přes dekádu podílí na vzdělávání české e-commerce díky odborným přednáškám a praktickým
            workshopům. Umožňuje přátelské setkání e-shoperů a e-commerce odborníků na jednom místě.
          </p>
          <br>
          <p class="lg:text-[18px] text-[14px] font-gray-900">
            Shopcamp vytváříme na míru pro zástupce předních a etablovaných e-shopů, kteří chtějí držet krok s
            nejnovějšími trendy a inovacemi v e-commerce.
          </p>
          <br>
          <p class="lg:text-[18px] text-[14px] font-gray-900 lg:mb-[70px]">
            Po celý den probíhá program ve dvou přednáškových sálech, třech workshopových místnostech a nově účastníkům
            představíme také inspirativní mastermindy vedené zkušenými odborníky české e-commerce. Program doplňují
            partnerské stánky, kolo štěstí, skvělé občerstvení, uvolněná komunitní atmosféra a neformální networking.
          </p>
        </div>
      </div>
    </div>
  </div>
  <Carousel class="mb-[107px] lg:mt-[50px]"></Carousel>
</template>
<script setup>

import Carousel from "../Ambience/Carousel.vue";
import Eshoper from "./Eshoper.vue";
import Standart from "./Standard.vue";
import Premium from "./Premium.vue";
import Substitute from "./Substitute.vue";
import Partner from "./Partner.vue";

const props = defineProps({
  freeRegistrationEnded: Boolean,
  isLateSimpleshopRegistrationOpened: Boolean,
  freeRegistrationIntervalIsActive: Boolean,
  freeRegistrationIntervalIsInFuture: Boolean,
  freeRegistrationIntervalStart: String,
  freeRegistrationIntervalEnd: String,
  eshoperIsFull: Boolean,
  isEarlySimpleshopRegistrationOpened: Boolean,
  earlySimpleshopRegistrationEnd: String,
  lateSimpleshopRegistrationStart: String,
  lateSimpleshopRegistrationEnd: String,
})
</script>
<style scoped>
</style>
